import {ObservableStatus, useUser} from 'reactfire';
import {AuthUser} from '../types';

/* v8 ignore next -- @preserve */
export function useAuthUser(): ObservableStatus<AuthUser> {
  return useUser() as ObservableStatus<AuthUser>;
}
